import { render, staticRenderFns } from "./TipoMandatoShow.vue?vue&type=template&id=82c9530e&scoped=true&"
import script from "./TipoMandatoShow.vue?vue&type=script&lang=js&"
export * from "./TipoMandatoShow.vue?vue&type=script&lang=js&"
import style0 from "./TipoMandatoShow.vue?vue&type=style&index=0&id=82c9530e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c9530e",
  null
  
)

export default component.exports